import React from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";

const MainTitle = ({ sx, ...props }) => {
  const ResponsiveTypography = () => {
    const theme = useTheme();

    // Define media queries for md and sm screen sizes
    const isMediumScreen = useMediaQuery(theme.breakpoints.only("md"));
    const isSmallScreen = useMediaQuery(theme.breakpoints.only("sm"));
    const isExtraSmallScreen = useMediaQuery(theme.breakpoints.only("xs"));

    // Determine the variant based on the screen size
    let variant = "h4"; // default variant
    if (isMediumScreen) {
      variant = "h4";
    } else if (isSmallScreen) {
      variant = "h5";
    } else if (isExtraSmallScreen) {
      variant = "h6";
    }

    return variant;
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "auto",
        flexDirection: "column",
        alignItems: "flex-start",
        ...sx,
      }}
    >
      <Typography
        align="left"
        variant={ResponsiveTypography()}
        sx={{ color: "white", mt: 1, mb: 0.5, fontWeight: "bold" }}
      >
        {`Precision in Carabao Insemination with AI Technology`}
      </Typography>
      <br></br>
    </Box>
  );
};

export default MainTitle;
